var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-1 mt-md-9"},[_c('ChatMensagens'),_c('ChatInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }